import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'CPDForge AI';
const SITE_URL = 'https://cpdforgeai.com';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.webp`;

// Brand Context resolver for SEO/meta. Professional keeps 'CPDForge AI';
// educational/community surfaces project to 'Hominid Labs'.
const SITE_NAME_BY_CONTEXT = {
  professional: SITE_NAME,
  educational: 'Hominid Labs',
  community: 'Hominid Labs',
};

export { SITE_URL, SITE_NAME };

export function PageMeta({ title, description, path, ogImage, ogType = 'website', brandContext = 'professional', children }) {
  const siteName = SITE_NAME_BY_CONTEXT[brandContext] || SITE_NAME;
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} — AI Compliance Training Platform`;
  const canonicalUrl = path ? `${SITE_URL}${path}` : undefined;
  const ogImageUrl = ogImage || DEFAULT_OG_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Open Graph */}
      <meta property="og:title" content={title || `${siteName} — AI Compliance Training Platform`} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={ogType} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:image" content={ogImageUrl} />
      <meta property="og:image:width" content="1536" />
      <meta property="og:image:height" content="1024" />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || `${siteName} — AI Compliance Training Platform`} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImageUrl} />

      {children}
    </Helmet>
  );
}
